import React from 'react';
import DocumentUploadProvider from './DocumentUploadContext';
import { AdditionalInfoProps } from './types';

const AdditionalInfo: React.FCC<AdditionalInfoProps> = (props) => (
    <DocumentUploadProvider {...props} />
);

export default AdditionalInfo;
